import React from "react";
import "./App.css";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      timeArray: this.getTimeArrays()
    };
    setInterval(() => {
      this.setState({ timeArray: this.getTimeArrays() });
    }, 1000);
  }
  getTimeArrays() {
    let hours = new Date().getHours();
    let firstRow = parseInt(hours / 5);
    let secondRow = parseInt(hours % 5);
    let minutes = new Date().getMinutes();
    let thirdRow = parseInt(minutes / 5);
    let fourthRow = parseInt(minutes % 5);
    let seconds = new Date().getSeconds();
    let fifthRow = parseInt(seconds / 5);
    let sixthRow = parseInt(seconds % 5);
    return [firstRow, secondRow, thirdRow, fourthRow, fifthRow, sixthRow];
  }

  render() {
    return (
      <div className="App">
        <header className="App-header">
          {this.state.timeArray.map(item => (
            <div style={{display:"flex", width:"calc(100% - 100px)",height:56,justifyContent:"center"}}>
              {new Array(item).fill(0).map(field => (
                <div
                  style={{
                    width: 40,
                    height: 40,
                    backgroundColor: "#fff",

                  margin:8
                  }}
                />
              ))}
            </div>
          ))}
        </header>
      </div>
    );
  }
}

export default App;
